import React from "react";

import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";

import Space from "../../commons/Space";
import SpaceL from "../../commons/SpaceL";

import insta from "../../icone/icons8-instagram-48.png";
import facebook from "../../icone/icons8-facebook-48.png";

function NuovaStagione() {
    return (
        <div>
            <ScrollToTopOnMount />

            <div style={container}>

                {/* =========================
                    HERO
                ========================= */}
                <div style={heroBox} className="text-center">

                    <h1 style={titleStyle}>
                        Si riparte!
                    </h1>

                    <h3>
                        La nuova stagione al Cigno sta per iniziare
                    </h3>

                    <p style={heroText}>
                        Dopo la pausa estiva, il Centro Sportivo Il Cigno
                        è pronto a tornare in movimento con una nuova stagione
                        di sport, energia e benessere.
                    </p>

                    <p style={heroLocation}>
                        <strong>
                            Il tuo centro sportivo a Sesto San Giovanni.
                        </strong>
                    </p>

                    <div style={mainDates}>

                        {/* 1 SETTEMBRE - RIAPERTURA */}
                        <div style={dateCardMain}>

                            <div style={dateNumber}>
                                1
                            </div>

                            <div>
                                <strong>SETTEMBRE</strong>

                                <br />

                                <span>
                                    Riapre il Cigno
                                </span>
                            </div>

                        </div>

                        {/* 1 SETTEMBRE - ISCRIZIONI */}
                        <div style={dateCard}>

                            <div style={dateNumber}>
                                1
                            </div>

                            <div>
                                <strong>SETTEMBRE</strong>

                                <br />

                                <span>
                                    Aprono le iscrizioni
                                </span>
                            </div>

                        </div>

                        {/* 14 SETTEMBRE - CORSI */}
                        <div style={dateCardHighlight}>

                            <div style={dateNumberHighlight}>
                                14
                            </div>

                            <div>
                                <strong>SETTEMBRE</strong>

                                <br />

                                <span>
                                    Ripartono i corsi di gruppo
                                </span>
                            </div>

                        </div>

                    </div>

                </div>

                <SpaceL />

                {/* =========================
                    RIAPERTURA
                ========================= */}
                <div style={openingBox}>

                    <div className="text-center">

                        <div style={openingIcon}>
                            ✨
                        </div>

                        <h2 style={sectionTitle}>
                            Dal 1° settembre il Cigno riapre
                        </h2>

                        <p>
                            Dal <strong>1° settembre</strong> il Centro Sportivo
                            Il Cigno di <strong>Sesto San Giovanni</strong> torna
                            operativo con le attività e i servizi già disponibili.
                        </p>

                    </div>

                    <div style={openingGrid}>

                        {/* NUOTO LIBERO */}
                        <a
                            href="/nuotolibero"
                            style={openingCard}
                        >

                            <div style={activityIcon}>
                                🏊
                            </div>

                            <h3>
                                Nuoto libero
                            </h3>

                            <p>
                                Torna in acqua e riprendi a nuotare
                                con i tuoi ritmi.
                            </p>


                        </a>

                        {/* PALESTRA */}
                        <a
                            href="/palestra"
                            style={openingCard}
                        >

                            <div style={activityIcon}>
                                🏋️
                            </div>

                            <h3>
                                Palestra
                            </h3>

                            <p>
                                Riprendi i tuoi allenamenti
                                e torna a prenderti cura di te.
                            </p>


                        </a>

                        {/* SPA */}
                        <a
                            href="/spa"
                            style={openingCard}
                        >

                            <div style={activityIcon}>
                                🧖
                            </div>

                            <h3>
                                SPA
                            </h3>

                            <p>
                                Relax e benessere per ritrovare
                                il tuo equilibrio.
                            </p>


                        </a>

                    </div>

                </div>

                <SpaceL />

                {/* =========================
                    CORSI DI GRUPPO
                ========================= */}
                <div style={coursesBox}>

                    <div className="text-center">

                        <div style={courseIcon}>
                            🤸
                        </div>

                        <h2 style={courseTitle}>
                            Dal 14 settembre ripartono i corsi di gruppo
                        </h2>

                        <p style={courseIntro}>
                            La nuova stagione dei corsi è pronta a ripartire!
                        </p>

                        <p>
                            Dal <strong>14 settembre</strong> tornano tutte
                            le attività di gruppo:
                            <strong> nuoto, fitness, danza, runnering</strong>
                            <br />
                            e tutte le altre attività in programma.
                        </p>

                    </div>

                    <div style={coursesGrid}>

                        {/* NUOTO */}
                        <a
                            href="/corsinuoto"
                            style={courseCard}
                        >

                            <div style={courseCardIcon}>
                                🏊
                            </div>

                            <strong>
                                Nuoto
                            </strong>

                            <span>
                                Corsi per bambini, ragazzi e adulti
                            </span>

                        </a>

                        {/* FITNESS */}
                        <a
                            href="/fitness"
                            style={courseCard}
                        >

                            <div style={courseCardIcon}>
                                🔥
                            </div>

                            <strong>
                                Fitness
                            </strong>

                            <span>
                                Movimento, energia e allenamento
                            </span>

                        </a>

                        {/* DANZA */}
                        <a
                            href="/danza"
                            style={courseCard}
                        >

                            <div style={courseCardIcon}>
                                💃
                            </div>

                            <strong>
                                Danza
                            </strong>

                            <span>
                                Tecnica, espressione e passione
                            </span>

                        </a>

                        {/* RUNNERING */}
                        <a
                            href="/runnering"
                            style={courseCard}
                        >

                            <div style={courseCardIcon}>
                                🏃
                            </div>

                            <strong>
                                Runnering
                            </strong>

                            <span>
                                Corsa, allenamento e performance
                            </span>

                        </a>

                    </div>

                    <div
                        className="text-center"
                        style={courseBottom}
                    >

                        <p>
                            <strong>
                                Le iscrizioni ai corsi sono aperte dal 1° settembre.
                            </strong>
                        </p>

                        <a
                            href="/"
                            className="btn"
                            style={courseButton}
                        >
                            Scopri tutte le attività
                        </a>

                    </div>

                </div>

                <SpaceL />

                {/* =========================
                    ATTIVITÀ
                ========================= */}
                <div style={activitiesBox}>

                    <div className="text-center">

                        <div style={locationSmall}>
                            IL CIGNO · SESTO SAN GIOVANNI
                        </div>

                        <h2 style={sectionTitle}>
                            Tutto il Cigno, tutto in un unico Centro
                        </h2>

                        <p>
                            Scopri le attività del Centro Sportivo Il Cigno
                            e scegli quella più adatta a te.
                        </p>

                    </div>

                    <div style={activitiesGrid}>

                        {/* NUOTO */}
                        <a
                            href="/piscina"
                            style={activityCard}
                        >

                            <div style={activityIcon}>
                                🏊
                            </div>

                            <h3>
                                Nuoto
                            </h3>

                            <p>
                                Corsi per bambini, ragazzi e adulti
                                e nuoto libero.
                            </p>

                            <span style={activityLink}>
                                Scopri →
                            </span>

                        </a>

                        {/* PALESTRA */}
                        <a
                            href="/palestra"
                            style={activityCard}
                        >

                            <div style={activityIcon}>
                                🏋️
                            </div>

                            <h3>
                                Palestra
                            </h3>

                            <p>
                                Allenamento e attività per raggiungere
                                i tuoi obiettivi.
                            </p>

                            <span style={activityLink}>
                                Scopri →
                            </span>

                        </a>

                        {/* FITNESS */}
                        <a
                            href="/fitness"
                            style={activityCard}
                        >

                            <div style={activityIcon}>
                                🔥
                            </div>

                            <h3>
                                Fitness
                            </h3>

                            <p>
                                Energia, movimento e divertimento
                                per stare in forma.
                            </p>

                            <span style={activityLink}>
                                Scopri →
                            </span>

                        </a>

                        {/* DANZA */}
                        <a
                            href="/danza"
                            style={activityCard}
                        >

                            <div style={activityIcon}>
                                💃
                            </div>

                            <h3>
                                Danza
                            </h3>

                            <p>
                                Tecnica, espressione e passione
                                per la danza.
                            </p>

                            <span style={activityLink}>
                                Scopri →
                            </span>

                        </a>

                        {/* RUNNERING */}
                        <a
                            href="/runnering"
                            style={activityCard}
                        >

                            <div style={activityIcon}>
                                🏃
                            </div>

                            <h3>
                                Runnering
                            </h3>

                            <p>
                                Allenamento e corsa per migliorare
                                forma e performance.
                            </p>

                            <span style={activityLink}>
                                Scopri →
                            </span>

                        </a>

                        {/* SPA */}
                        <a
                            href="/spa"
                            style={activityCard}
                        >

                            <div style={activityIcon}>
                                🧖
                            </div>

                            <h3>
                                SPA
                            </h3>

                            <p>
                                Uno spazio dedicato al relax
                                e al benessere.
                            </p>

                            <span style={activityLink}>
                                Scopri →
                            </span>

                        </a>

                    </div>

                </div>

                <SpaceL />

                {/* =========================
                    ISCRIZIONI
                ========================= */}
                <div style={registrationBox}>

                    <div style={registrationBadge}>
                        ISCRIZIONI DAL 1° SETTEMBRE
                    </div>

                    <h2
                        style={sectionTitle}
                        className="text-center"
                    >
                        Pronto a scegliere la tua attività?
                    </h2>

                    <p className="text-center">
                        Dal 1° settembre puoi venire in segreteria
                        per scoprire i corsi, conoscere gli orari
                        e iscriverti alla nuova stagione.
                    </p>

                    <div style={registrationSteps}>

                        <div style={registrationCard}>

                            <div style={step}>
                                1
                            </div>

                            <h3>
                                Scopri le attività
                            </h3>

                            <p>
                                Scegli il corso più adatto a te
                                o alla tua famiglia.
                            </p>

                        </div>

                        <div style={registrationCard}>

                            <div style={step}>
                                2
                            </div>

                            <h3>
                                Vieni al Cigno
                            </h3>

                            <p>
                                Dal 1° settembre la segreteria
                                è pronta ad accoglierti.
                            </p>

                        </div>

                        <div style={registrationCard}>

                            <div style={step}>
                                3
                            </div>

                            <h3>
                                Inizia il tuo percorso
                            </h3>

                            <p>
                                Dal 1° settembre apertura per
                                nuoto libero, palestra e SPA.
                                <br />
                                Dal 14 settembre ripartono
                                tutti i corsi di gruppo.
                            </p>

                        </div>

                    </div>

                </div>

                <SpaceL />

                {/* =========================
                    CTA
                ========================= */}
                <div
                    className="text-center"
                    style={ctaBox}
                >

                    <div style={locationSmall}>
                        SESTO SAN GIOVANNI
                    </div>

                    <h2 style={sectionTitle}>
                        Ci vediamo al Cigno!
                    </h2>

                    <p>
                        Nuoto, palestra, fitness, danza, runnering e SPA:
                        <br />
                        una nuova stagione ti aspetta.
                    </p>

                    <a
                        href="/chisiamo"
                        className="btn"
                        style={ctaButton}
                    >
                        Scopri il Cigno
                    </a>

                    <div style={contacts}>

                        <p>
                            📞 02 2401 006
                        </p>

                        <p>
                            ✉️ info@ilcignosport.it
                        </p>

                        <p>
                            📍 Via Fiorani, 74 - Sesto San Giovanni
                        </p>

                    </div>

                    <div style={social}>

                        <a
                            href="https://www.instagram.com/centrosportivoilcigno/?hl=it"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src={insta}
                                alt="Instagram Il Cigno"
                            />
                        </a>

                        <a
                            href="https://www.facebook.com/ilcignosport.it/?locale=it_IT"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src={facebook}
                                alt="Facebook Il Cigno"
                            />
                        </a>

                    </div>

                </div>

                <Space />

            </div>

        </div>
    );
}


/* =========================
   STILI GENERALI
========================= */

const container = {
    padding: "1em",
    maxWidth: "1000px",
    margin: "0 auto"
};


/* =========================
   HERO
========================= */

const heroBox = {
    background: "linear-gradient(135deg, #fff5f2, #ffffff)",
    padding: "2.5em 2em",
    borderRadius: "20px"
};

const titleStyle = {
    color: "#EC635B",
    fontFamily: "Wedges",
    fontSize: "3em",
    marginBottom: "0.3em"
};

const heroText = {
    maxWidth: "700px",
    margin: "1em auto 0"
};

const heroLocation = {
    color: "#4B8DA4",
    fontSize: "1.15em",
    marginTop: "1em"
};

const mainDates = {
    display: "flex",
    flexDirection: "column",
    gap: "1em",
    marginTop: "2em",
    maxWidth: "650px",
    marginLeft: "auto",
    marginRight: "auto"
};

const dateCard = {
    display: "flex",
    alignItems: "center",
    gap: "1.2em",
    background: "#ffffff",
    padding: "1em 1.5em",
    borderRadius: "18px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.07)",
    textAlign: "left"
};

const dateCardMain = {
    display: "flex",
    alignItems: "center",
    gap: "1.2em",
    background: "#EEF8F2",
    padding: "1em 1.5em",
    borderRadius: "18px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.07)",
    textAlign: "left",
    border: "2px solid #D8EDE0"
};

const dateCardHighlight = {
    display: "flex",
    alignItems: "center",
    gap: "1.2em",
    background: "#EAF8FC",
    padding: "1em 1.5em",
    borderRadius: "18px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.07)",
    textAlign: "left",
    border: "2px solid #D8F1F7"
};

const dateNumber = {
    fontSize: "2.5em",
    fontWeight: "bold",
    color: "#EC635B",
    lineHeight: "1"
};

const dateNumberHighlight = {
    fontSize: "2.5em",
    fontWeight: "bold",
    color: "#4B8DA4",
    lineHeight: "1"
};


/* =========================
   RIAPERTURA
========================= */

const openingBox = {
    background: "#EEF8F2",
    padding: "2.5em 2em",
    borderRadius: "22px",
    boxShadow: "0 8px 25px rgba(0,0,0,0.05)"
};

const openingIcon = {
    fontSize: "2.5em",
    marginBottom: "0.3em"
};

const openingGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "1em",
    marginTop: "1.8em"
};

const openingCard = {
    background: "white",
    padding: "1.5em",
    borderRadius: "18px",
    textAlign: "center",
    boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
    textDecoration: "none",
    color: "inherit",
    cursor: "pointer",
    display: "block",
    transition: "transform 0.2s ease, box-shadow 0.2s ease"
};


/* =========================
   CORSI DI GRUPPO
========================= */

const coursesBox = {
    background: "linear-gradient(135deg, #EAF8FC, #ffffff)",
    padding: "2.5em 2em",
    borderRadius: "22px",
    boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
    border: "2px solid #D8F1F7"
};

const courseIcon = {
    fontSize: "3em"
};

const courseTitle = {
    color: "#4B8DA4",
    fontSize: "2em",
    marginBottom: "0.5em"
};

const courseIntro = {
    fontSize: "1.15em",
    fontWeight: "bold"
};

const coursesGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "1em",
    marginTop: "1.8em"
};

const courseCard = {
    background: "white",
    padding: "1.3em",
    borderRadius: "18px",
    textAlign: "center",
    boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
    gap: "0.4em",
    textDecoration: "none",
    color: "inherit",
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease"
};

const courseCardIcon = {
    fontSize: "2em",
    marginBottom: "0.2em"
};

const courseBottom = {
    marginTop: "1.8em"
};

const courseButton = {
    backgroundColor: "#4B8DA4",
    borderColor: "#4B8DA4",
    color: "white",
    padding: "0.8em 1.5em",
    fontWeight: "bold"
};


/* =========================
   ATTIVITÀ
========================= */

const activitiesBox = {
    background: "#ffffff",
    padding: "2em 1em"
};

const sectionTitle = {
    color: "#EC635B",
    marginBottom: "0.5em"
};

const locationSmall = {
    color: "#4B8DA4",
    fontSize: "0.8em",
    fontWeight: "bold",
    letterSpacing: "0.08em",
    marginBottom: "0.6em"
};

const activitiesGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "1.2em",
    marginTop: "1.5em"
};

const activityCard = {
    background: "#FAFAFA",
    padding: "1.5em",
    borderRadius: "18px",
    textAlign: "center",
    boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
    textDecoration: "none",
    color: "inherit",
    cursor: "pointer",
    display: "block",
    transition: "transform 0.2s ease, box-shadow 0.2s ease"
};

const activityIcon = {
    fontSize: "2.5em",
    marginBottom: "0.3em"
};

const activityLink = {
    color: "#4B8DA4",
    fontWeight: "bold",
    textDecoration: "none"
};

const cardLink = {
    display: "inline-block",
    marginTop: "0.5em",
    color: "#4B8DA4",
    fontWeight: "bold"
};


/* =========================
   ISCRIZIONI
========================= */

const registrationBox = {
    background: "#FFF5F2",
    padding: "2em",
    borderRadius: "20px",
    textAlign: "center",
    boxShadow: "0 8px 20px rgba(0,0,0,0.05)"
};

const registrationBadge = {
    display: "inline-block",
    background: "#EC635B",
    color: "white",
    padding: "0.5em 1em",
    borderRadius: "50px",
    fontSize: "0.85em",
    fontWeight: "bold",
    marginBottom: "1em"
};

const registrationSteps = {
    display: "flex",
    flexDirection: "column",
    gap: "1em",
    marginTop: "1.5em"
};

const registrationCard = {
    background: "white",
    padding: "1.5em",
    borderRadius: "18px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
};

const step = {
    fontSize: "2.5em",
    color: "#EC635B",
    fontWeight: "bold"
};


/* =========================
   CTA
========================= */

const ctaBox = {
    padding: "2em"
};

const ctaButton = {
    padding: "1em 2em",
    fontSize: "1.2em",
    backgroundColor: "#4B8DA4",
    borderColor: "#4B8DA4",
    color: "white"
};

const contacts = {
    marginTop: "2em",
    fontSize: "0.9em",
    color: "gray"
};

const social = {
    display: "flex",
    justifyContent: "center",
    gap: "1em",
    marginTop: "1em"
};


export default NuovaStagione;